import memoize from 'memoize-one';
import { getCurrentBucketId } from './bucketSelectors';
import { getFilterMembersCallback } from '../helpers/Util';

/* Memoize function for bucket members map */
const mapBucketMembers = memoize((users, members) =>
    members.map(membership => ({
        ...users[membership.userId],
        isAdmin: membership.isAdmin,
    })),
);

const filterBucketMembers = memoize((members, filterTerm) => {
    const filterCallback = getFilterMembersCallback(filterTerm);
    return members.filter(filterCallback);
});

export const getBucketMembersSearchTerm = state => {
    return state.bucketMembersFilter.searchTerm;
};

export const getMembers = (state, bucketId = getCurrentBucketId(state)) => {
    const members = state.usersByBuckets[bucketId];
    if (!members) {
        return undefined;
    }
    const users = state.db.users;
    return mapBucketMembers(users, members).sort((a, b) =>
        `${a.firstName} ${a.lastName}`.localeCompare(
            `${b.firstName} ${b.lastName}`,
        ),
    );
};

export const getFilteredMembers = (
    state,
    bucketId = getCurrentBucketId(state),
) => {
    const members = getMembers(state, bucketId);
    if (!members) {
        return undefined;
    }
    const filterTerm = getBucketMembersSearchTerm(state);
    return filterBucketMembers(members, filterTerm);
};

export const getIsLoadingMembers = (
    state,
    bucketId = getCurrentBucketId(state),
) => !!state.membersOfBuckets.loading[bucketId];

export const getError = state => state.membersOfBuckets.error;



// WEBPACK FOOTER //
// ./src/selectors/bucketMembersSelectors.js